import { DEBUG } from "../../../config";
import Parser from "../restapi/parser";
import worker from "../setupWorker";
import store from "../store";
import { getCurDate, getCurrentTime } from "../utils/DateTimeUtils";
import { tienFormat } from "../utils/NumberUtils";
import { buildSMSMB } from "../working/CanChuyenLib";
import { LotteryLoaiCuoc, One789BetTypes, One789GameTypes, OneMapBetType, Price, Ticket, TicketItem, TicketPlay } from "./oneTypes";

export function buildPlayData(
    gameType: One789GameTypes,
    betType: One789BetTypes,
    mapResult: Map<string, any>,
    price?: any,
) {
    let result: TicketPlay = { IgnorePrice: true, Term: getCurDate(), Tickets: [] };
    let priceMap: Map<string, number> = new Map();
    if (price) {
        if (price.length > 0) {
            priceMap = getPriceMap(price[0])
        }
    }
    switch (betType) {
        case One789BetTypes.De:
            result = extractLoaiCuoc(mapResult, 'De', priceMap, gameType)
            break;
        case One789BetTypes.Lo:
            result = extractLoaiCuoc(mapResult, 'Lo', priceMap, gameType)
            break;
        case One789BetTypes.LoA:
            result = extractLoaiCuoc(mapResult, 'LoA', priceMap, gameType)
            break;
        case One789BetTypes.DeA:
            result = extractLoaiCuoc(mapResult, 'DeA', priceMap, gameType)
            break;
        case One789BetTypes.G1:
            result = extractLoaiCuoc(mapResult, 'Giai1', priceMap, gameType)
            break;
        case One789BetTypes.G1A:
            result = extractLoaiCuoc(mapResult, 'Giai1A', priceMap, gameType)
            break;
        case One789BetTypes.LoLive:
            result = extractLoaiCuoc(mapResult, 'Lo', priceMap, gameType)
            break;
        case One789BetTypes.D3:
            result = extractLoaiCuoc(mapResult, '3c', priceMap, gameType)
            break;
    }
    return result;
}
export function buildPlayDataXi234(
    gameType: One789GameTypes,

    mapResult: Map<string, any>,
    price?: any,
): TicketPlay {
    const mainTicket = extractLoaiCuoc(mapResult, 'Xi2', price, gameType);
    addTicketToMain(mapResult, 'Xi3', price, mainTicket, gameType);
    addTicketToMain(mapResult, 'Xi4', price, mainTicket, gameType);
    return mainTicket;
}
export function mapLoaiCuocToOne789(loaiCuoc: LotteryLoaiCuoc): One789BetTypes {
    let ret: One789BetTypes = One789BetTypes.De;
    switch (loaiCuoc) {
        case 'De':
            ret = One789BetTypes.De;
            break;
        case 'Lo':
            ret = One789BetTypes.Lo;
            break;
        case 'DeA':
            ret = One789BetTypes.DeA;
            break;
        case 'LoA':
            ret = One789BetTypes.LoA;
            break;
        case 'Giai1':
            ret = One789BetTypes.G1;
            break;
        case 'Giai1A':
            ret = One789BetTypes.G1A;
            break;
        case 'Xi2':
            ret = One789BetTypes.X2;
            break;
        case 'Xi3':
            ret = One789BetTypes.X3;
            break;
        case 'Xi4':
            ret = One789BetTypes.X4;
            break;
        case '3c':
            ret = One789BetTypes.D3;
            break;
        default:
            console.error('Không map được loại cược này sang One789 ', loaiCuoc);
            break;
    }
    return ret;
}
export function extractLoaiCuoc(mapResult: Map<string, any>, loaiCuoc: LotteryLoaiCuoc,
    priceMap: Map<string, number>, gameType: number
): TicketPlay {
    const result: TicketPlay = createMainTicket();
    addTicketToMain(mapResult, loaiCuoc, priceMap, result, gameType);
    return result;
}
export function addTicketToMain(mapResult: Map<string, any>, loaiCuoc: LotteryLoaiCuoc,
    priceMap: Map<string, number>, mainTicket: TicketPlay,
    gameType: number): TicketPlay {
    const ticket: Ticket = {
        BetType: mapLoaiCuocToOne789(loaiCuoc),
        GameType: gameType,
        Items: []
    }
    const tickets = mainTicket.Tickets!;
    tickets.push(ticket);
    for (let [key, so] of mapResult) {
        const arr = key.split(';');
        const [dai, loai, diem] = arr;
        ////////////
        if (loai != loaiCuoc)
            continue;
        //////////////
        let arrNumbers = [];
        if (',Xi2,Xi3,Xi4,'.includes(loaiCuoc)) {
            arrNumbers = so.split('/')
        } else {
            arrNumbers = so.split(',');
        }
        for (let num of arrNumbers) {
            const diemNum = Math.floor(Number(diem))
            if (diemNum > 0) {
                let priceAll = priceMap.get('ALL')
                let priceExtra = priceMap.get(num)
                let priceTotal = priceAll!;
                if (priceExtra) {
                    priceTotal += priceExtra!;
                }
                if (!',Xi2,Xi3,Xi4,'.includes(loaiCuoc)) {
                    const ticketItem: TicketItem = {
                        Numbers: [num],
                        Point: diemNum,
                        Price: priceTotal ? priceTotal : 0
                    }
                    ticket.Items!.push(ticketItem)
                } else {
                    // các loại xiên
                    const nums = num.split(',');
                    const ticketItem: TicketItem = {
                        Numbers: [...nums],
                        Point: diemNum,
                        Price: priceTotal ? priceTotal : 0
                    }
                    ticket.Items!.push(ticketItem)

                }
            }
        }
    }

    mainTicket.Tickets = tickets;
    if (DEBUG) {
        console.log(mainTicket);
    }
    return mainTicket;

}
export function createMainTicket(): TicketPlay {
    const result: TicketPlay = {
        IgnorePrice: true,
        Term: getCurDate(),
        Tickets: [],
    };

    return result;
}
/*build map gía theo từng số, loại cược đã được xác định trước đó rồi, ko quan tâm nữa*/
export function getPriceMap(price: Price): Map<string, number> {
    const ret = new Map<string, any>()
    ret.set('ALL', price.Price);
    if (price.Numbers && price.Numbers.length > 0) {
        for (let num of price.Numbers) {
            ret.set(num.Number, num.ExtraPrice);
        }
    }
    return ret;
}
export function buildLotteryDataFromTicket(tickcetPlay: TicketPlay) {
    let sms = '';
    const map = new Map<string, string>();//'dai.;loai;diem' : 'day so'
    if (tickcetPlay.Tickets) {
        for (let ticket of tickcetPlay.Tickets) {
            if (ticket.Items) {
                const loaiText = OneMapBetType.get(ticket.BetType)!
                for (let item of ticket.Items) {
                    const key = `HN.;${loaiText};${item.Point}`
                    let mapEitem = map.get(key);
                    if (!mapEitem) {
                        const numbers = item.Numbers.join(',');
                        map.set(key, numbers)
                    } else {
                        if (isXien(ticket.BetType)) {
                            mapEitem = mapEitem + '/' + item.Numbers.join(',')
                        } else {
                            mapEitem = mapEitem + ',' + item.Numbers.join(',')
                        }
                        map.set(key, mapEitem)
                    }
                }
            }
        }
    }
    if (map.size > 0) {
        sms = buildSMSMB(map, 5000)[0]
        if (DEBUG)
            console.log(sms)
    }
    return sms
}
function isXien(betType: One789BetTypes) {
    return betType == One789BetTypes.X2 || betType == One789BetTypes.X3 ||
        betType == One789BetTypes.X4;
}

export function parseBetMessage(sms: string, chuId: number) {
    const body = {
        body: sms,
        date: store.getState().global.workDate,
        time: getCurrentTime(),
        type: 2,
        contactId: chuId,
        curMien: 'BAC',
        getCompactData: 1,
        getRawData: 0,
        lockArea: true,
        editedMessageId: 0,

    }
    Parser.parseMessage(body).then(result => {

        if (result.data.parseStatus == "parseOK") {
            worker.postMessage({ type: 'showsnackbar', data: 'Cược thành công,đã trừ số liệu' })
        }

    })
}